import { useEffect, useState } from 'react'
import ThemeToggle from './ThemeToggle'
import { useCV } from '../hooks/useCV'

const items = [
  { name: 'Skills', id: 'skills' },
  { name: 'Experience', id: 'experience' },
  { name: 'Projects', id: 'projects' },
  { name: 'Contact', id: 'contact' },
]

const Navigation = () => {
  const { name, contact } = useCV()
  const [scrolled, setScrolled] = useState(false)
  const [active, setActive] = useState('')

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 8)
      let current = ''
      for (const item of items) {
        const el = document.getElementById(item.id)
        if (el && el.getBoundingClientRect().top <= 140) current = item.id
      }
      setActive(current)
    }
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 bg-paper/90 backdrop-blur transition-colors ${
        scrolled ? 'border-b border-rule' : 'border-b border-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-3 sm:py-0 sm:h-16 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-6">
        <div className="flex items-center justify-between">
          <a href="#" className="font-serif text-xl font-medium tracking-tight">
            {name}
          </a>
          <span className="sm:hidden">
            <ThemeToggle />
          </span>
        </div>
        <nav aria-label="Main" className="flex items-center gap-5 text-sm">
          {items.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              aria-current={active === item.id ? 'true' : undefined}
              className={`transition-colors underline-offset-8 decoration-accent decoration-2 hover:text-ink ${
                active === item.id ? 'text-ink underline' : 'text-mute'
              }`}
            >
              {item.name}
            </a>
          ))}
          {contact.resume && (
            <a
              href={contact.resume}
              target="_blank"
              rel="noopener noreferrer"
              className="text-accent font-medium hover:underline underline-offset-4"
            >
              Resume
            </a>
          )}
          <span className="hidden sm:block sm:ml-2">
            <ThemeToggle />
          </span>
        </nav>
      </div>
    </header>
  )
}

export default Navigation
